import { useMemo } from 'react';

import { ChakraBox, DateFormat, DatePickerInput, Text } from '@equip.health/ui';
import { DateTime } from 'luxon';

import { EMPTY_PLACEHOLDER } from '~/components/maud/patients/treatmentEpisode/Types';

export interface DateViewProps {
  id: string;
  isReadOnly: boolean;
  maxDate?: Date;
  minDate?: Date;
  onChange: (newValue: Date) => void;
  value?: Date;
}

const DateView = ({
  id,
  isReadOnly,
  maxDate,
  minDate,
  onChange,
  value,
}: DateViewProps) => {
  const dtStr = useMemo(
    () =>
      value ? DateTime.fromJSDate(value).toFormat(DateFormat.longDate) : null,
    [value],
  );

  return (
    <ChakraBox>
      {isReadOnly ? (
        <Text color={dtStr ? 'neutral.primary' : 'neutral.tertiary'} id={id}>
          {dtStr ?? EMPTY_PLACEHOLDER}
        </Text>
      ) : (
        <DatePickerInput
          defaultDate={value}
          id={`${id}__edit`}
          maxDate={maxDate}
          minDate={minDate}
          onSubmit={(value) => onChange(value)}
          placeholder="Please choose"
          showTimeInput={false}
        />
      )}
    </ChakraBox>
  );
};

export default DateView;
